import React from 'react'
import { FormControl } from 'react-bootstrap'
import { get } from 'lodash'
import Group from './group'

const Title = ({
    value = {},
    onChange = () => {}
}) => {
    return (
        <React.Fragment>
            <Group label='URL'>
                <FormControl
                    value={get(value, 'url', '') || ''}
                    onChange={e => onChange({ ...value, url: e.target.value})}
                    placeholder='Enter URL'
                />
            </Group>
        </React.Fragment>
    )
}

export default Title